export const alertConstants = {
  ALERT_ERROR: "ALERT_ERROR",
  ALERT_INFO: "ALERT_INFO",
  ALERT_SUCCESS: "ALERT_SUCCESS",
  ALERT_WARNING: "ALERT_WARNING",
};